"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  StudyBook: ['study-book', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.173,18.219a21.108,21.108,0,0,0-6.014-1.06A1.491,1.491,0,0,1,.75,15.664V2.3A1.5,1.5,0,0,1,2.354.8C8.678,1.131,12,3.388,12,5.114,12,3.4,15.715,1.157,21.641.806a1.5,1.5,0,0,1,1.609,1.5v12.6', 'M12 5.114L12 9.001', 'M9.342,6.548a24.432,24.432,0,0,0-5.574-1.3', 'M19.414,9.221q.519-.084,1.063-.155', 'M9.342,10.363a25.012,25.012,0,0,0-5.574-1.3', 'M9.342,14.406a25.247,25.247,0,0,0-5.625-1.3', 'M14.9,6.555a25.221,25.221,0,0,1,5.628-1.3', 'M23.136,23.251l.1-1.122a3,3,0,0,0-2.337-3.2l-3.651-.811V12.376a1.875,1.875,0,1,0-3.75,0v9.205l-1.477-1.108a1.533,1.533,0,0,0-2.146,2.146l.474.632']],
  StudyLightIdea: ['study-light-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 2.251L12 0.751', 'M18.364 4.888L19.425 3.827', 'M21 11.251L22.5 11.251', 'M18.364 17.615L19.425 18.676', 'M5.636 4.888L4.575 3.827', 'M3 11.251L1.5 11.251', 'M5.636 17.615L4.575 18.676', 'M9,16.449v2.3a3,3,0,0,0,6,0v-2.3', 'M6.000 11.251 A6.000 6.000 0 1 0 18.000 11.251 A6.000 6.000 0 1 0 6.000 11.251 Z', 'M12 21.751L12 23.251']],
  StudyBrain1: ['study-brain-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.245,7.5a3.75,3.75,0,1,1,5.255.756', 'M23.25,9a4.5,4.5,0,0,1-4.5,4.5h-1.5', 'M4.563 10.501L6.75 10.501', 'M7.063,13.5a1.5,1.5,0,0,1,1.5,1.5v3', 'M17.25,22.5V18H19.5a3.749,3.749,0,0,0,2.8-6.24A4.5,4.5,0,0,0,18.75,4.5a4.525,4.525,0,0,0-.812.075,3.75,3.75,0,0,0-7.438.675c0,.088,0,.175.01.261A4.5,4.5,0,0,0,4.563,10.5H4.5a3.75,3.75,0,0,0,0,7.5H8.563a3.75,3.75,0,0,0,5.687,1.5v3', 'M14.25,19.5v-3a1.5,1.5,0,0,0-1.5-1.5h-1.5']],
  StudyExamMath: ['study-exam-math', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5 3.751L7.5 9.751', 'M4.5 6.751L10.5 6.751', 'M18.75 10.501L14.25 15.001', 'M14.25 10.501L18.75 15.001', 'M5.25 17.251L10.5 17.251', 'M7.875,14.251a.375.375,0,0,1,.375.375', 'M7.5,14.626a.375.375,0,0,1,.375-.375', 'M7.875,15a.374.374,0,0,1-.375-.375', 'M8.25,14.626A.374.374,0,0,1,7.875,15', 'M7.875,19.5a.375.375,0,0,1,.375.375', 'M7.5,19.876a.375.375,0,0,1,.375-.375', 'M7.875,20.251a.374.374,0,0,1-.375-.375', 'M8.25,19.876a.374.374,0,0,1-.375.375', 'M22.5,21.751a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V2.251A1.5,1.5,0,0,1,3,.751H18.036a1.5,1.5,0,0,1,1.049.427L22.047,4.06A1.5,1.5,0,0,1,22.5,5.134Z']],
  StudyNotebookMaths: ['study-notebook-maths', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.822,13.387l-6.51,8.606L12.7,23.251l.228-3.817,6.51-8.606a2.115,2.115,0,0,1,2.963-.411l.01.007A2.116,2.116,0,0,1,22.822,13.387Z', 'M9,23.251H2.25a1.556,1.556,0,0,1-1.5-1.607V5.359a1.557,1.557,0,0,1,1.5-1.608h19.5a1.557,1.557,0,0,1,1.5,1.608V6.751', 'M5.25 0.751L5.25 5.251', 'M9.75 0.751L9.75 5.251', 'M14.25 0.751L14.25 5.251', 'M18.75 0.751L18.75 5.251', 'M3.75,9.376A1.125,1.125,0,0,1,4.875,8.251h0A1.125,1.125,0,0,1,6,9.376H6a1.6,1.6,0,0,1-.351,1l-1.9,2.373H6', 'M12.75,8.251h.75a.75.75,0,0,1,.75.75v3.75', 'M12.75 12.751L15 12.751', 'M9.75 9.001L9.75 12.001', 'M8.25 10.501L11.25 10.501']],
  StudyBrain: ['study-brain', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,17.366A3.286,3.286,0,0,0,5.715,14.08c-.053,0-.1.013-.154.016', 'M5.561,10.021c.052,0,.1.016.154.016A3.286,3.286,0,0,0,9,6.751', 'M12 6.001L12 18.001', 'M15,17.366a3.286,3.286,0,0,1,3.285-3.286c.053,0,.1.013.154.016', 'M18.439,10.021c-.052,0-.1.016-.154.016A3.286,3.286,0,0,1,15,6.751', 'M23.25,12a3,3,0,0,0-2.183-2.886A2.248,2.248,0,0,0,19.684,5.26a2.3,2.3,0,0,0-.411-.364,3,3,0,0,0-5.461-2.478,2.249,2.249,0,0,0-3.624,0A3,3,0,0,0,4.727,4.9a2.3,2.3,0,0,0-.411.364A2.248,2.248,0,0,0,2.933,9.115a3,3,0,0,0,0,5.773,2.248,2.248,0,0,0,1.383,3.855,2.3,2.3,0,0,0,.411.364,3,3,0,0,0,5.461,2.477,2.249,2.249,0,0,0,3.624,0,3,3,0,0,0,5.461-2.477,2.3,2.3,0,0,0,.411-.364,2.248,2.248,0,0,0,1.383-3.855A3,3,0,0,0,23.25,12Z']],
  StudyDesk: ['study-desk', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.125,15.789H1.875a.749.749,0,0,1-.727-.568l-.375-1.5a.749.749,0,0,1,.727-.932h21a.749.749,0,0,1,.727.932l-.375,1.5A.749.749,0,0,1,22.125,15.789Z', 'M3 15.789L1.5 23.289', 'M21 15.789L22.5 23.289', 'M14.25,12.789a3,3,0,0,1,6,0', 'M15,2.289a2.25,2.25,0,0,1,2.25,2.25v5.25', 'M10.824,1.539A3,3,0,0,1,14.25,6.465Z', 'M10.473,12.789H3.75a1.5,1.5,0,0,1,0-3h6.723', 'M8.973 9.789L8.973 12.789', 'M10.473,9.789H3.75a1.5,1.5,0,0,1,0-3h6.723', 'M8.973 6.789L8.973 9.789']],
  StudyMathsBrain: ['study-maths-brain', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.475,3.93c-1.853,2.333-2.94,5.71-4.325,9.3a.751.751,0,0,0,.7,1.02h1.9v3a3,3,0,0,0,3,3h1.5v3', 'M18.75,23.251V16.986a9.379,9.379,0,0,0,2.787-4.868', 'M21 1.501L21 6.001', 'M18.75 3.751L23.25 3.751', 'M12.75 9.751L18 9.751', 'M15.375,6.751a.375.375,0,0,1,.375.375', 'M15,7.126a.375.375,0,0,1,.375-.375', 'M15.375,7.5A.374.374,0,0,1,15,7.126', 'M15.75,7.126a.374.374,0,0,1-.375.375', 'M15.375,12a.375.375,0,0,1,.375.375', 'M15,12.376A.375.375,0,0,1,15.375,12', 'M15.375,12.751A.374.374,0,0,1,15,12.376', 'M15.75,12.376a.374.374,0,0,1-.375.375', 'M9 3.001L9.75 3.751 10.5 0.751 15 0.751']],
  StudyOwl: ['study-owl', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.4,5.144,20.25,3,12.4.859a1.512,1.512,0,0,0-.79,0L3.75,3l7.855,2.143A1.512,1.512,0,0,0,12.4,5.144Z', 'M17.25 7.154L17.25 3.82', 'M7.5 4.024L7.5 6.847', 'M3.75 3.001L3.75 6.001', 'M5.250 9.751 A3.000 3.000 0 1 0 11.250 9.751 A3.000 3.000 0 1 0 5.250 9.751 Z', 'M8.25,9.376a.375.375,0,0,0-.375.375', 'M8.625,9.751a.375.375,0,0,0-.375-.375', 'M8.25,10.126a.375.375,0,0,0,.375-.375', 'M7.875,9.751a.375.375,0,0,0,.375.375', 'M12.750 9.751 A3.000 3.000 0 1 0 18.750 9.751 A3.000 3.000 0 1 0 12.750 9.751 Z', 'M15.75,9.376a.375.375,0,0,0-.375.375', 'M16.125,9.751a.375.375,0,0,0-.375-.375', 'M15.75,10.126a.375.375,0,0,0,.375-.375', 'M15.375,9.751a.375.375,0,0,0,.375.375', 'M9.484 12.486L12 15.001 14.516 12.486', 'M18,15v2.337a6,6,0,0,1-12,0V15', 'M18.225,11.447a3.132,3.132,0,0,1,3.525,3.076v2.065a5.217,5.217,0,0,1-5.732,5.142', 'M5.657,11.262A3.149,3.149,0,0,0,2.25,14.4v2.1A5.251,5.251,0,0,0,7.982,21.73']]
};
exports["default"] = _default;